import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Params, ActivatedRoute, Router } from '@angular/router';

import { AppConstants } from 'appshared/app-constants';
import * as Models from 'appshared/shared-models';
import { MiscTools } from 'appshared/misc-tools';
import { TextTools } from 'appshared/text-tools';
import { SharedLicenseTools } from 'appshared/shared-license-tools';

import { AuthService } from 'client/app/services/auth.service';
import { UiAlertsService } from 'client/app/components/ui-alerts/ui-alerts.service';
import { LicensingService } from '../licensing.service';

import { KeyInfoComponent } from 'client/app/components/shared/key-info/key-info.component';

@Component({
	selector: 'app-activation-multi',
	templateUrl: './activation-multi.component.html',
	styleUrls: ['./activation-multi.component.scss']
})
export class ActivationMultiComponent implements OnInit, OnDestroy {
	ac = AppConstants;
	tt = TextTools;
	slt = SharedLicenseTools;
	mt = MiscTools;

	@ViewChild(KeyInfoComponent) keyInfo: KeyInfoComponent = null;

	pageMode: string = 'activation'; // or host or aggregate or ip
	tabID: string = '';
	id: number; // activation ID
	hostid: string;
	ip: string;
	authUser: Models.AuthUser;
	userKey: Models.UserLicenseKey; // for shared code for non-staff mode

	filterID: number = 0;

	// *********************************************************
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private authService: AuthService,
		private uiAlertsService: UiAlertsService,
		private licensingService: LicensingService) {

		this.route.queryParams.subscribe(params => {
			this.tabID = null;
			if (params['tabID']) this.tabID = params['tabID'];
		});

		this.route.paramMap.subscribe(params => {
			this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };

			/*
			/XXX - page mode is 'activation' & id is ###
			/activation|hostid|aggregate/XXX - page mode is one of 3 and id is +XXX or hostid is XXX or (eventually) collection id is +XXX
			/aggregate - page mode is aggregate and manual entry is available...
			*/
			const pagemodeArg = params.get('pagemode');
			const objidArg = params.get('objid');

			// console.log('in route pm=' + this.pageMode);
			// console.log('in route pagemodeArg=' + pagemodeArg);


			if (['activation', 'hostid', 'host', 'activation', 'ip', 'aggregate'].includes(pagemodeArg)) {
				// // this.pageMode = pagemodeArg;
				// if (this.pageMode === 'host') this.pageMode = 'hostid';

				if (pagemodeArg === 'activation') {
					this.pageMode = 'activation';
					this.id = +objidArg;
				} else if (['hostid', 'host'].includes(pagemodeArg)) {
					this.pageMode = 'hostid';
					this.hostid = objidArg;
					if (params.get('filterID') && params.get('filterID') !== '') {
						this.filterID = +params.get('filterID');
						if (isNaN(this.filterID)) this.filterID = 0;
					} // if
				} else if (pagemodeArg === 'ip') {
					this.pageMode = 'ip';
					this.ip = objidArg;
				} else if (pagemodeArg === 'aggregate') {
					this.pageMode = 'aggregate';
				} // if

			} else {
				this.pageMode = 'activation';
				this.id = +pagemodeArg;
			} // if

			if (this.id && isNaN(this.id)) this.id = null;

			// console.log('pageMode=' + this.pageMode);
			// console.log('id=' + this.id);
			// console.log('hostid=' + this.hostid);
		});
	}

	// *********************************************************
	ngOnInit(): void {
		// console.log('in ngOnInit pm=' + this.pageMode);
		const sessionUser: Models.AuthUser = this.authService.getUser();
		if (sessionUser != null && sessionUser.id !== 0) {
			this.authUser = sessionUser;
			this.loadData();
		} // if
	}

	// *********************************************************
	ngOnDestroy(): void {
		//
	}

	// *********************************************************
	async loadData() {

		let compCheckCounter: number = 0;
		let compCheckMax: number = 10;
		while (!this.keyInfo && compCheckCounter < compCheckMax) {
			compCheckCounter++;
			// give it a chance to load
			await MiscTools.delay(100);
		} // if

		if (!this.keyInfo) {
			alert('Cannot find keyInfo component - contact support');
			return;
		} // if

		// hmm.....
		let activation: Models.LPActivation = null;
		if (this.pageMode === 'activation') {
			activation = await this.licensingService.getOne(this.id);
			if (!activation || activation == null || activation.id === 0) {
				this.router.navigate([AppConstants.urls.notfound]);
				return;
			} // if
		}
		this.keyInfo.setupComponent(this.authUser, this.pageMode, activation, null, this.hostid, this.ip, this.tabID, this.filterID);
	}
}
